import { render, staticRenderFns } from "./lp-payment.vue?vue&type=template&id=1f3c049d&"
import script from "./lp-payment.vue?vue&type=script&lang=js&"
export * from "./lp-payment.vue?vue&type=script&lang=js&"
import style0 from "./lp-payment.vue?vue&type=style&index=0&id=1f3c049d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports